<ng-container *ngIf="loaderService.isLoading | async">
  <div class="popup-smokescreen"></div>
  <div class="popup-container">
    <ui-title class="title" titleText="{{ title | translate }}"></ui-title>
    <p class="subtitle">{{ "loader.subTitle" | translate }}</p>
    <ng-lottie class="fugu-loader" [options]="options"></ng-lottie>
  </div>
</ng-container>
